
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import PageTopTitle from '../../components/shared/PageTopTitle'
import { showModal } from '../../features/modal/modalSlice'
import VerticalDndKKK from '../../components/dnd/VerticalDndKKK'
import Button from '../../components/shared/Button'
import { useEffect } from 'react'
import { getKKK, updateKKK } from '../../features/adminSett/adminSettSlice'

const Container = styled.div`
width: 100%;

.wrapper{
    display: flex;
    flex-direction: column;
    width: 100%;

    .content{
      width: calc(100% - 60px);
      gap: 60px;
      margin: 30px;


      .top-container{
        width: 100%;
        display: flex;
        justify-content: flex-end;
        margin: 20px 0;
      }


      .list{
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 20px;
      }
    }
}
`

const KamyoonKullanimKurallariAdmin = () => {

    const {KKKList} = useSelector(state => state.adminSett)

    const dispatch = useDispatch()

    useEffect(() => {
      dispatch(getKKK())
    },[])

  return (
    <Container>
    <div className="wrapper">
      <PageTopTitle title={"Kamyoon Kullanım Kuralları"} position='sticky'/>
      <div className="content">
        <div className="top-container">
            <Button color={"#F4F4F4"} background={"#0EAC00"} width="180px" radius={"10px"} text={"Kural Ekle"} padding="0 10px" handleClick={() => dispatch(showModal("addKKKItem"))}/>
        </div>
        {
          (KKKList && KKKList.length > 0) && 
          <div className="list">
            <VerticalDndKKK data={KKKList}/>
          </div>
        }
      </div>
    </div>
  </Container>
  )
}

export default KamyoonKullanimKurallariAdmin